/* eslint-disable no-nested-ternary */
import { Input, Option } from '../../interfaces';
import TextInput from './TextInput';
import SelectInput from './SelectInput';
import MultiSelectInput from './MultiSelectInput';
import DollarInput from './DollarInput';
import TextareaInput from './TextareaInput';
import ImageUpload from './ImageUpload';
import StyledPhoneInput from './PhoneInput';
import LinkInput from './LinkInput';
import PercentInput from './PercentInput';
import DateRangeInput from './DateRangeInput';
import DateInput from './DateInput';
import TimeInput from './TimeInput';
import ColorInput from './ColorInput';

interface Props {
  inputs: Input[];
  values: any;
  setFieldValue: (
    field: string,
    value: any,
    shouldValidate?: boolean | undefined,
  ) => void;
  formName: string;
}

export default function InputRow({
  inputs,
  values,
  setFieldValue,
  formName,
}: Props) {
  return (
    <div className="input-row">
      {inputs.map(input =>
        input.type === 'text' || input.type === 'number' ? (
          <TextInput
            name={input.name}
            label={input.label}
            placeholder={input.placeholder}
            key={`${input.name}-${formName}`}
            disabled={input.disabled}
            type={input.type}
            min={input.min}
            max={input.max}
            step={input.step}
          />
        ) : input.type === 'color' ? (
          <ColorInput
            label={input.label}
            disabled={input.disabled}
            name={input.name}
            colors={input.colors}
            tooltip={input.tooltip}
          />
        ) : input.type === 'dollar' ? (
          <DollarInput
            name={input.name}
            label={input.label}
            placeholder={input.placeholder}
            key={`${input.name}-${formName}`}
            values={values}
            setFieldValue={setFieldValue}
            disabled={
              input.disabled
                ? values[input.disabled.field] !== input.disabled.changesWhen
                  ? input.disabled.start
                  : !input.disabled.start
                : false
            }
            hidden={
              input.hidden
                ? values[input.hidden.field] === ''
                  ? input.hidden.start
                  : values[input.hidden.field] !== input.hidden.changesWhen
                : false
            }
            tooltip={input.tooltip}
          />
        ) : input.type === 'select' && input.options ? (
          <SelectInput
            values={values}
            setFieldValue={setFieldValue}
            autoWidth={input.autoWidth}
            validateChange={input.validateChange}
            name={input.name}
            label={input.label}
            options={input.options}
            placeholder={input.placeholder}
            key={`${input.name}-${formName}`}
            disabled={input.disabled}
            tooltip={input.tooltip}
            hidden={
              input.hidden
                ? values[input.hidden.field] === ''
                  ? input.hidden.start
                  : values[input.hidden.field] !== input.hidden.changesWhen
                : false
            }
          />
        ) : input.type === 'multiselect' ? (
          <MultiSelectInput
            name={input.name}
            label={input.label}
            autoWidth={input.autoWidth}
            options={input.options as Option<string>[]}
            placeholder={input.placeholder}
            disabled={input.disabled}
            tooltip={input.tooltip}
            hidden={
              input.hidden
                ? values[input.hidden.field] === ''
                  ? input.hidden.start
                  : values[input.hidden.field] !== input.hidden.changesWhen
                : false
            }
            allText={input.allText}
            showListWithAll={input.showListWithAll}
            hideAllOption={input.hideAllOption}
            key={`${input.name}-${formName}`}
          />
        ) : input.type === 'textarea' ? (
          <TextareaInput
            name={input.name}
            label={input.label}
            placeholder={input.placeholder}
            helperText={input.helperText}
            key={`${input.name}-${formName}`}
          />
        ) : input.type === 'image' ? (
          <ImageUpload
            name={input.name}
            values={values}
            setFieldValue={setFieldValue}
            key={`${input.name}-${formName}`}
          />
        ) : input.type === 'phone' ? (
          <StyledPhoneInput
            name={input.name}
            label={input.label}
            placeholder={input.placeholder}
            key={`${input.name}-${formName}`}
            search={false}
            disabled={input.disabled}
          />
        ) : input.type === 'link' ? (
          <LinkInput
            name={input.name}
            label={input.label}
            placeholder={input.placeholder}
            prependText={input.prependText}
            disabled={input.disabled}
            key={`${input.name}-${formName}`}
          />
        ) : input.type === 'percent' ? (
          <PercentInput
            name={input.name}
            label={input.label}
            placeholder={input.placeholder}
            helperText={input.helperText}
            key={`${input.name}-${formName}`}
            hidden={
              input.hidden
                ? values[input.hidden.field] === ''
                  ? input.hidden.start
                  : values[input.hidden.field] !== input.hidden.changesWhen
                : false
            }
          />
        ) : input.type === 'date-range' ? (
          <DateRangeInput
            key={`${input.name}-${formName}`}
            name={input.name}
            label={input.label}
            disabled={input.disabled}
            hidden={input.hidden}
            minDate={input.minDate}
          />
        ) : input.type === 'date' ? (
          <DateInput
            key={`${input.name}-${formName}`}
            name={input.name}
            label={input.label}
            disabled={input.disabled}
            hidden={input.hidden}
            minDate={input.minDate}
          />
        ) : input.type === 'time' ? (
          <TimeInput
            key={`${input.name}-${formName}`}
            name={input.name}
            label={input.label}
            disabled={input.disabled}
            hidden={input.hidden}
            minDate={input.minDate}
            displayEmpty={input.displayEmpty}
            minutesStep={input.minutesStep}
          />
        ) : null,
      )}
    </div>
  );
}
